<script setup lang="ts">
  // Uses AppThemeSelector for popover-based theme selection
</script>

<template>
  <AppThemeSelector />
</template>
